import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { Check, PencilSquare, Plus, Trash3, X } from "react-bootstrap-icons";
import LoadingSpinner from "../../../../../../components/loading-spinner/LoadingSpinner";
import AddCity from "../add-city/AddCity";
import {
  fetchCities,
  removeCityItem,
  setEditCityObject,
  updateCityStatus,
} from "../../../../../../store/slices/RoutesSlice";
import { useDispatch, useSelector } from "react-redux";
import EditCity from "../edit-city/EditCity";
import toast from "react-hot-toast";

const AdminCitiesTab = () => {
  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const handleClose = () => setShow(false);
  const handleEditClose = () => setShowEdit(false);
  const { cities, isCitiesLoading } = useSelector((state) => state.routes);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCities());
  }, []);

  const removeCity = (id) => {
    // confirm before deleting
    if (!window.confirm("Are you sure you want to delete this item?")) return;
    dispatch(removeCityItem(id));
    toast.success("City Removed Successfully", {
      duration: 4000,
    });
  };

  const updateStatus = (cityId, status) => {
    dispatch(updateCityStatus({ cityId, status }));
    toast.success("Status Updated Successfully", {
      duration: 4000,
    });
  };

  const editCity = (city) => {
    dispatch(setEditCityObject(city));
    setShowEdit(true);
  };

  return (
    <Container fluid>
      <AddCity show={show} handleClose={handleClose} />
      <EditCity show={showEdit} handleClose={handleEditClose} />
      <Row className="mb-3">
        <Col md="auto">
          <Button
            variant="light"
            className="border fw-semibold d-flex align-items-center"
            onClick={() => setShow(true)}
          >
            <Plus size={20} />
            Add City
          </Button>
        </Col>
      </Row>

      {isCitiesLoading ? (
        <LoadingSpinner />
      ) : (
        <Table responsive hover striped>
          <thead>
            <tr>
              <th className="text-nowrap">#</th>
              <th className="text-nowrap">Name</th>
              <th className="text-nowrap">Status</th>
              <th className="text-nowrap">Actions</th>
            </tr>
          </thead>
          <tbody>
            {cities.map((city, index) => (
              <tr key={city._id}>
                <td className="text-nowrap">{index + 1}</td>
                <td className="text-nowrap">{city.name}</td>
                <td className="text-nowrap">
                  <div className="d-flex flex-row justify-content-start align-items-center gap-2">
                    <select
                      className="form-select form-select-sm w-auto"
                      defaultValue={city.status}
                      onChange={(e) => {
                        updateStatus(city._id, e.target.value);
                      }}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                    <div
                      className={` ${
                        city.status == "active" ? "bg-success" : "bg-secondary"
                      } rounded-circle d-flex justify-content-center align-items-center`}
                      style={{ width: "20px", height: "20px" }}
                    >
                      {city.status == "active" ? (
                        <Check className="text-white" size={17} />
                      ) : (
                        <X className="text-white" size={17} />
                      )}
                    </div>
                  </div>
                </td>
                <td className="text-nowrap">
                  <Button
                    variant="primary"
                    size="sm"
                    className="me-2"
                    onClick={() => {
                      editCity(city);
                    }}
                  >
                    <PencilSquare />
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => {
                      removeCity(city._id);
                    }}
                  >
                    <Trash3 />
                  </Button>
                </td>
              </tr>
            ))}
            {cities.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default AdminCitiesTab;
